import Raven from 'raven-js';
import InlineFeedback from 'ai-components-ui-library/components/feedback/InlineFeedback';
import { NOT_USING_TRACKER } from 'ai-components-ui-library/hooks/useTracker';
import { useAcademyChatActions } from '../../context/AcademyChatActionsContext';
import { hasNarrativeText } from '../../utils/getVisibleChatMessages';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getInitialVote = message => {
  var _message$feedback, _message$feedback2;
  if (((_message$feedback = message.feedback) === null || _message$feedback === void 0 ? void 0 : _message$feedback.type) === 'THUMBS_UP') {
    return 1;
  }
  if (((_message$feedback2 = message.feedback) === null || _message$feedback2 === void 0 ? void 0 : _message$feedback2.type) === 'THUMBS_DOWN') {
    return -1;
  }
  return undefined;
};
export const AssistantMessageWrapper = ({
  message,
  children
}) => {
  const {
    submitFeedback,
    isStreaming,
    isOnboardingFlow
  } = useAcademyChatActions();
  const turnId = message.turnId;
  const handleCustomFeedback = e => {
    void submitFeedback(Object.assign({
      type: e.vote === 1 ? 'THUMBS_UP' : 'THUMBS_DOWN',
      turnId
    }, e.feedbackMessage ? {
      text: e.feedbackMessage
    } : {}, e.options && e.options.length > 0 ? {
      tags: e.options
    } : {})).catch(Raven.captureException.bind(Raven));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, message.role === 'ASSISTANT' && typeof turnId === 'number' && !isOnboardingFlow && !isStreaming && hasNarrativeText(message) && /*#__PURE__*/_jsx(InlineFeedback, {
      messageId: turnId,
      initialVote: getInitialVote(message),
      onNegativeFeedback: handleCustomFeedback,
      onPositiveFeedback: handleCustomFeedback,
      usageTracker: NOT_USING_TRACKER
    })]
  });
};